export default {"src":"/_next/static/media/accident_40.5cec9af4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};